import React, { FC } from 'react';

import { Typography, useTheme } from '@mui/material';
import { styled } from '@mui/material';
import { Link } from 'react-router-dom';

import PathwaySmallIcon from '~/assets/icons/PathwaySmallIcon';
import Trans from '~/components/Trans';
import { buildPathwayRoute } from '~/routes';
import { TINY_MARGIN_PX } from '~/theme';

interface PathwayInfoRowProps {
  name?: string | null;
  slug?: string | null;
}

const PathwayInfoRow: FC<PathwayInfoRowProps> = ({ name, slug }) => {
  const theme = useTheme();
  return (
    <Wrapper>
      <StyledIcon color={theme.palette.common.blue} />
      <PathwayText>
        <Trans i18nKey="page.video.videoModuleFreeIsPart" values={{ name }}>
          This video module is part of the
          <PathwayLink to={buildPathwayRoute(slug)}>{name}</PathwayLink>
          Pathway
        </Trans>
      </PathwayText>
    </Wrapper>
  );
};

export default PathwayInfoRow;

const Wrapper = styled('div')`
  display: flex;
  align-items: center;
`;
const StyledIcon = styled(PathwaySmallIcon)`
  width: 24px;
  height: 24px;
  margin-right: ${TINY_MARGIN_PX};
`;
const PathwayText = styled(Typography)`
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.common.gray};
`;
const PathwayLink = styled(Link)`
  color: ${({ theme }) => theme.palette.common.white};
  font-weight: bold;
`;
